var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portfolio_edit_wrap"},[_c('div',{staticClass:"portfolio_edit_title"},[_vm._v(" "+_vm._s(_vm.$t('portfolio'))+" ")]),_c('member-write-component',{attrs:{"memberType":'portfolioEdit',"memberKey":_vm.UserInfo.mb_no}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }